var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 76,
    viewBox: "0 0 303 76",
    fill: "none",
    className: "pattern",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6917 -30.3347L86.6709 -42.3555L-25.8516 70.167L-13.8307 82.1878L98.6917 -30.3347ZM242.692 -30.3347L230.671 -42.3555L118.148 70.167L118.268 70.2862L46.2617 142.292L58.2825 154.313L169.809 42.7864L169.69 42.6673L242.692 -30.3347ZM110.71 -18.3193L122.731 -6.29852L10.2117 106.221L-1.8091 94.1998L110.71 -18.3193ZM266.731 -6.29852L254.71 -18.3193L142.191 94.1998L142.318 94.3272L70.311 166.335L82.3318 178.355L191.856 68.8314L191.728 68.7039L266.731 -6.29852ZM134.249 6.22461L146.27 18.2454L34.2449 130.27L22.2241 118.25L134.249 6.22461ZM290.27 18.2454L278.249 6.22461L166.224 118.25L178.245 130.27L290.27 18.2454ZM313.809 42.7864L301.788 30.7656L190.262 142.292L202.283 154.313L313.809 42.7864ZM335.856 68.8314L323.835 56.8105L214.311 166.335L226.332 178.355L335.856 68.8314Z",
    fill: "url(#paint0_linear_6917_40112)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6917_40112",
    x1: -25.8516,
    y1: 67.9999,
    x2: 210.69,
    y2: 240.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F374",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81EDB2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.62ca39c6a5dab34524db3693b5519bf9.svg";
export { ForwardRef as ReactComponent };